import {LotoCardboardRepository} from "../ports/LotoCardboardRepository";
import {validateLotoCardboardNumbers} from "../../domain/services/LotoCardboardValidator";

type UpdatePayload = {id: string; changes: {numbers?: string[]; label?: string; rows?: string[][]; barcode?: string}};

export class UpdateLotoCardboard {
    constructor(private readonly repo: LotoCardboardRepository) {}

    async execute({id, changes}: UpdatePayload): Promise<void> {
        if (changes.numbers) {
            const validation = validateLotoCardboardNumbers(changes.numbers);
            if (!validation.valid) throw new Error(validation.errors.join(" • "));
        }
        await this.repo.update(id, changes);
    }
}
